import { Form, Formik } from 'formik';
import { useState } from 'react';

import authApis from '../../../APIs/auth';
import { ReactComponent as MailSVG } from '../../../assets/icons/Mail.svg';
import { ReactComponent as MobileNumberSVG } from '../../../assets/icons/phone.svg';
import { ReactComponent as UserSVG } from '../../../assets/icons/User.svg';
import { useRoot } from '../../../context/RootProvider';
import {
  Alert,
  Button,
  FormContainer,
  Input,
  SelectDropdown,
  Typography,
} from '../../../designComponents';
import { requestAPI } from '../../../utils';
import { ActiveComponentType } from '.';
import { Container } from './onboardingForms.style';
import validation from './validation';

// type OnboardingParamType = {
//   onboardingStep: number;
//   fullName: string;
//   role: string;
//   mobileNumber: string;
//   countryCode: string;
// };

const PersonalInformation = ({
  initialState,
  setCurrentStep,
}: ActiveComponentType) => {
  const { updateAuth } = useRoot();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const handleContinue = async (values: typeof initialState) => {
    if (
      values.fullName &&
      values.userType &&
      values.userType &&
      values.mobileNumber
    ) {
      try {
        setErrorMessage('');
        setLoading(true);
        const onBoardingData = await requestAPI(
          authApis.onBoarding({
            onboardingStep: 1,
            fullName: values.fullName,
            role: values.userType,
            mobileNumber: values.mobileNumber,
            countryCode: values.mobileNumber,
          })
        );
        setLoading(false);
        setCurrentStep((prev) => prev + 1);

        updateAuth(onBoardingData.user);
      } catch (error: any) {
        if (typeof error === 'string') {
          setErrorMessage(error);
        }
        if (error.error && typeof error.error === 'string') {
          setErrorMessage(error.error);
        }
        console.error(error);
        setLoading(false);
      }
    }
  };

  return (
    <Container>
      <Typography variant="title" className="title">
        Personal Information
      </Typography>
      {errorMessage && (
        <div style={{ marginBottom: '5px' }}>
          <Alert text={errorMessage} type="error" />
        </div>
      )}
      <Formik
        initialValues={initialState}
        enableReinitialize
        onSubmit={handleContinue}
        validationSchema={validation.personalInformation}
      >
        {({ values, setFieldValue, errors, handleSubmit, touched }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer
                label="User Type"
                error={touched.userType ? errors.userType : ''}
                marginBottom="20px"
              >
                <SelectDropdown
                  icons={<UserSVG />}
                  onSelect={(value: string, _record: any) => {
                    setFieldValue('userType', value);
                  }}
                  selected={values.userType || ''}
                  name="userType"
                  placeholder="Select a user type"
                  options={[
                    {
                      label: 'Client',
                      value: 'CLIENT',
                      record: {
                        label: 'Client',
                        value: 'CLIENT',
                      },
                    },
                    {
                      label: 'Technician',
                      value: 'TECHNICIAN',
                      record: {
                        label: 'Technician',
                        value: 'TECHNICIAN',
                      },
                    },
                    {
                      label: 'Printer',
                      value: 'PRINTER',
                      record: {
                        label: 'Printer',
                        value: 'PRINTER',
                      },
                    },
                    {
                      label: 'Admin',
                      value: 'ADMIN',
                      record: {
                        label: 'Admin',
                        value: 'ADMIN',
                      },
                    },
                  ]}
                />
              </FormContainer>
              <FormContainer
                label="Full Name"
                marginBottom="20px"
                error={touched?.fullName ? errors.fullName : ''}
              >
                <Input
                  name="fullName"
                  value={values.fullName || ''}
                  iconLeft={<UserSVG />}
                  onChange={(e) => setFieldValue('fullName', e.target.value)}
                  placeholder="Full Name"
                />
              </FormContainer>

              <FormContainer
                label="Email Address"
                marginBottom="20px"
                error={touched?.emailAddress ? errors.emailAddress : ''}
              >
                <Input
                  type="email"
                  value={values.emailAddress || ''}
                  onChange={(e) =>
                    setFieldValue('emailAddress', e.target.value)
                  }
                  readOnly
                  iconLeft={<MailSVG />}
                  placeholder="Email"
                />
              </FormContainer>
              <FormContainer
                label="Mobile Number"
                marginBottom="20px"
                error={touched?.mobileNumber ? errors.mobileNumber : ''}
              >
                <Input
                  type="number"
                  value={values.mobileNumber || ''}
                  onChange={(e) =>
                    setFieldValue('mobileNumber', e.target.value)
                  }
                  iconLeft={<MobileNumberSVG />}
                  placeholder="Mobile numbers"
                />
              </FormContainer>

              <Button variant="secondary" htmlType="submit" isLoading={loading}>
                Continue
              </Button>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default PersonalInformation;
